import React from 'react';
import Banner from '../components/Technologies/banner';
import UniqueKA from '../components/Technologies/uniqueKA';
import SlidesUniqueKA from '../components/Technologies/SlidesUniqueKA';
import KA from '../components/Technologies/ka';
import KAMobile from '../components/Technologies/KAMobile';
import TechStack from '../components/Technologies/TechStack';

function Technologies() {
  return (
    <>
    <div className='w-full bg-white overflow-hidden px-4 sm:px-16 xl:px-0'>
      <div className='container mx-auto py-6 my-[120px]'>
        <Banner />
      </div>
    </div>
    <div className='w-full bg-gradient-to-r from-[#202020] via-[#352f2a] to-[#ecb07b] overflow-hidden px-4 sm:px-16 xl:px-0'>
      <div className='container mx-auto pt-[54px] lg:py-6 xl:mt-[30px] xl:mb-[45px]'>
        <UniqueKA />
      </div>
    </div>
    <div className='w-full bg-white overflow-hidden px-4 sm:px-16 xl:px-0'>
        <div className='container mx-auto py-6 mt-[98px] xl:mb-[55px]'>
          <SlidesUniqueKA />
      </div>
    </div>
    <div className='w-full bg-gradient-to-r from-[#202020] via-[#352f2a] to-[#ecb07b] overflow-hidden'>
        <div className='container mx-auto py-6 my-[120px] xl:mb-[170px] hidden xl:block'>
          <KA />
      </div>
      <div className='container mx-auto inline-flex xl:hidden'>
          <KAMobile />
      </div>
    </div>
    <div className='w-full bg-white overflow-hidden px-4 sm:px-16 xl:px-0'>
        <div className='container mx-auto py-6 mt-[98px] xl:mb-[55px]'>
          <TechStack />
        </div>
    </div>
    </>
  );
}

export default Technologies; 